import { CircularProgress, Stack, Typography } from '@mui/material'
import { useLazyGetGrowthToolsPageQuery } from '../../../../api/growthTools'
import { GrowthToolsList } from '../../../../components/GrowthTools/GrowthToolsList'
import { useGrowthToolsQueryArgs } from '../../../../hooks/useGrowthToolsQueryArgs'
import { useGrowthToolsWindowedPage } from '../../../../hooks/useGrowthToolsWindowedPage'

export const GrowthToolsAll = () => {
  const { queryArgs, resetKey } = useGrowthToolsQueryArgs()
  const [loadGrowthToolsPage] = useLazyGetGrowthToolsPageQuery()
  const { items, hasMore, isInitialLoading, isFetchingMore, isError, loadMore } =
    useGrowthToolsWindowedPage(resetKey, loadGrowthToolsPage, queryArgs)

  if (isInitialLoading && items.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight="100%">
        <CircularProgress />
      </Stack>
    )
  }

  if (isError) {
    return (
      <Typography color="error" textAlign="center" px={2}>
        Не удалось загрузить инструменты роста
      </Typography>
    )
  }

  return (
    <GrowthToolsList
      growthTools={items}
      hasMore={hasMore}
      isLoadingMore={isFetchingMore}
      onLoadMore={loadMore}
    />
  )
}
